import { getDecoratedRequestUrl } from '@/shared/request/request';
import axios from 'axios';
import { useRef } from 'react';

export default function useGetLocalSearchData() {
  const localSearchIndexData = useRef<any[] | null>(null);
  const localSearchIndexSettings = useRef<any | null>(null);

  const getLocalSearchIndexData = async (
    dataPreviewURL: string,
    options: Parameters<typeof getDecoratedRequestUrl>[1],
  ) => {
    if (localSearchIndexData.current) return localSearchIndexData.current;
    try {
      const { data: indexDataRes } = await axios<any[]>(
        getDecoratedRequestUrl(dataPreviewURL, options),
        {
          method: 'GET',
          params: {
            timestamp: new Date().getTime(),
          },
          headers: {
            'X-CACHE-TIMESTAMP': Date.now(),
          },
        },
      );
      localSearchIndexData.current = indexDataRes;
      return indexDataRes;
    } catch (error) {
      console.error('getLocalSearchIndexData error', error);
      return null;
    }
  };

  const getLocalSearchIndexSettings = async (
    dataPreviewURL: string,
    options: Parameters<typeof getDecoratedRequestUrl>[1],
  ) => {
    if (localSearchIndexSettings.current) return localSearchIndexSettings.current;
    try {
      const { data: indexSettingsRes } = await axios(
        getDecoratedRequestUrl(dataPreviewURL, options),
        {
          method: 'GET',
          params: {
            timestamp: new Date().getTime(),
          },
          headers: {
            'X-CACHE-TIMESTAMP': Date.now(),
          },
        },
      );
      localSearchIndexSettings.current = indexSettingsRes;
      return indexSettingsRes;
    } catch (error) {
      console.error('getLocalSearchIndexSettings error', error);
      return null;
    }
  };

  return {
    getLocalSearchIndexData,
    getLocalSearchIndexSettings,
  };
}
